module.exports = __webpack_public_path__ + "static/media/btn_certificado.a0f08632.svg";